import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { Chip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  GridActionsCellItem,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { FreigthForwarderType } from "../../../../../types/freightForwarder";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEditFreigthForwarder: (id: number | string) => void;
  onDeleteFreigthForwarder: (id: number | string) => void;
  onViewFreigthForwarder: (id: number | string) => void;
  data: FreigthForwarderType[];
  [x: string]: any;
}

export const renderMenus = (
    onViewFreigthForwarder,
    onEditFreigthForwarder,
    onDeleteFreigthForwarder,
    row,
) => {
  return [
    <GridActionsCellItem
        sx={{
          display:
              hasClaim("Interface Freight Forwarder - Maintenance") ||
              hasClaim("Freight Forwarder - Visualization")
                  ? "block"
                  : "none",
        }}
        key={`view-${row.ID_AGENTE_CARGA}`}
        icon={<VisibilityIcon />}
        label="View"
        onClick={() => onViewFreigthForwarder(row.ID_AGENTE_CARGA)}
        color="inherit"
        data-testid="view-button"
    />,
    <GridActionsCellItem
        sx={{
          display: hasClaim("Interface Freight Forwarder - Maintenance")
              ? "block"
              : "none",
        }}
        key={`edit-${row.ID_AGENTE_CARGA}`}
        icon={<EditIcon />}
        label="Edit"
        onClick={() => onEditFreigthForwarder(row.ID_AGENTE_CARGA)}
        color="inherit"
        data-testid="edit-button"
    />,
    <GridActionsCellItem
        sx={{
          display: hasClaim("Interface Freight Forwarder - Maintenance")
              ? "block"
              : "none",
        }}
        key={`delete-${row.ID_AGENTE_CARGA}`}
        icon={<DeleteIcon />}
        label="Delete"
        onClick={() => onDeleteFreigthForwarder(row.ID_AGENTE_CARGA)}
        color="inherit"
        data-testid="delete-button"
    />,
  ];
};

export const columns = (
    onViewFreigthForwarder,
    onEditFreigthForwarder,
    onDeleteFreigthForwarder,
) => {
  return [
    {
      field: "NOME_AGENTE",
      headerName: "Interface name",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "TIPO_INTERFACE",
      headerName: "Interface by",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "ATIVO",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Date>) =>
          params.value ? (
              <Chip label="Active" color="primary" />
          ) : (
              <Chip label="Inactive" variant="outlined" />
          ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(
          onViewFreigthForwarder,
          onEditFreigthForwarder,
          onDeleteFreigthForwarder,
          row,
      ),
    },
  ]
};

export default function DataTable({
  onEditFreigthForwarder,
  onDeleteFreigthForwarder,
  onViewFreigthForwarder,
  data,
  ...props
}: DataTableProps) {
  return (
    <>
      <DataTableDefault
        rowId={data.map((row) => row.ID_AGENTE_CARGA)}
        data-testid="freigthForwarder-data-table"
        data={data}
        columns={columns(
            onViewFreigthForwarder,
            onEditFreigthForwarder,
            onDeleteFreigthForwarder,
        )}
        {...props}
      />
    </>
  );
}
